import styled from 'styled-components';

interface Props {
    state: string;
}

export const FadeTransition = styled.div<Props>`
    transition: 0.5s;
    opacity: ${({ state }) => {
        switch (state) {
            case 'from':
                return '0';
            case 'enter':
                return '1';
            case 'leave':
                return '0';
        }
    }};
`;
